import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { ReactComponent as IconTriangleFilled } from 'media/svg/triangleFilled.svg';

import styles from '../ToggleBar.module.scss';

interface ToggleButtonProps {
    filterCount: number;
    children: ReactNode;
}

const ToggleButton = ({ filterCount, children }: ToggleButtonProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    return (
        <>
            <div
                role={'button'}
                className={classNames(styles.ToggleButton, {
                    [styles.Active]: isOpen,
                })}
                onClick={() => {
                    setIsOpen((isOpen) => !isOpen);
                }}
                onKeyUp={() => {
                    setIsOpen((isOpen) => !isOpen);
                }}
                tabIndex={-1}
            >
                <span
                    className={styles.Label}
                    dangerouslySetInnerHTML={{
                        __html: t('TRANS-selected-filter', {
                            count: filterCount,
                        }),
                    }}
                />
                <IconTriangleFilled />
            </div>
            <div className={styles.ToggleContent}>{isOpen && children}</div>
        </>
    );
};

export default ToggleButton;
